<div class="tab-container" [class.col-md-3]="stacked" [class.col-sm-4]="stacked">
  <ul class="nav nav-pills" [class.nav-stacked]="stacked">

    <li
      role="presentation"
      *ngFor="let tab of tabContentChildren"
      class="clickable"
      (click)="selectTab(tab)"
      [ngClass]="{ 'active': tab.isActive, 'has-error': !tab.isActive && useTabColors && tab.hasError, 'is-ok': !tab.isActive && useTabColors && !tab.hasError }">
      <a>{{ tab.title }}</a>
    </li>
  </ul>
</div>
<div [class.col-md-9]="stacked" [class.col-sm-8]="stacked">
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/vertical-tab-group/vertical-tab-group.component.html